import React from "react";
import churchFacade from "../assets/img/church/church1.jpg";

export default function ArchMasstimings() {
  const scheduleItems = [
    {
      badge: "Sunday",
      isDevotion: false,
      title: "Sunday Masses",
      time: "Morning 06:00 AM • 07:00 AM & Evening 06:00 PM",
      icon: "fas fa-church"
    },
    {
      badge: "Everyday",
      isDevotion: false,
      title: "Daily Eucharistic Celebration",
      time: "Morning 06:00 AM & Evening 06:00 PM",
      icon: "fas fa-calendar-day"
    },
    {
      badge: "Tuesday",
      isDevotion: true,
      title: "St. Antony's Novena & Mass",
      time: "Evening 06:00 PM — Novena & Benediction",
      icon: "fas fa-pray"
    },
    {
      badge: "Friday",
      isDevotion: true,
      title: "Sacred Heart of Jesus Novena",
      time: "Evening 06:00 PM — Novena Mass",
      icon: "fas fa-heart"
    },
    {
      badge: "Saturday",
      isDevotion: true,
      title: "Our Lady of Sorrows Novena",
      time: "Evening 06:00 PM — Marian Devotion & Mass",
      icon: "fas fa-star"
    }
  ];

  return (
    <section id="masstimings" className="arch-section py-5">
      <div id="architecture" className="container py-4">
        {/* Section Heading */}
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-cross"></i>
            <span>Architecture & Worship</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)" }}>
            Sacred Architecture & Liturgical Schedule
          </h2>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "700px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            Discover the beauty of Roman and European sacred architecture and join our parish family for the celebration of Holy Mass.
          </p>
        </div>

        <div className="row g-5 align-items-center">
          {/* Architecture Showcase */}
          <div className="col-lg-6">
            <div className="p-4 p-md-5 rounded-4" style={{ background: "#fcfbf8", border: "1px solid #ebdcb7", boxShadow: "0 6px 24px rgba(27, 58, 107, 0.05)" }}>
              <span className="badge mb-3" style={{ background: "#f5eedb", color: "#997327", border: "1px solid #ebdcb7", fontSize: "0.8rem", letterSpacing: "1px", textTransform: "uppercase", padding: "6px 14px" }}>
                Romanesque & Continental Splendor
              </span>
              <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy-dark)", fontSize: "1.85rem", marginBottom: "16px" }}>
                Architectural Splendor of the Cathedral
              </h3>

              <p style={{ textAlign: "justify", lineHeight: "1.8", color: "var(--cathedral-text-secondary)", marginBottom: "16px" }}>
                Still standing majestically and captivating visitors with its incomparable architectural beauty, St. Mary's Cathedral is a place worth exploring in the historical city of Madurai. An impeccable amalgamation of various architectural styles such as European, Continental, and Roman, the cathedral stands as an enduring monument to devotion.
              </p>

              <p style={{ textAlign: "justify", lineHeight: "1.8", color: "var(--cathedral-text-secondary)", marginBottom: "24px" }}>
                The cathedral is renowned for its captivating features: two towering 42-meter Romanesque bell towers that rise gracefully into the Madurai skyline, and an ornate, dignified façade that welcomes pilgrims into an atmosphere of reverent prayer and peace.
              </p>

              <div className="d-flex align-items-center gap-3 p-3 rounded-3" style={{ background: "#ffffff", border: "1px solid #eae2d1" }}>
                <img
                  src={churchFacade}
                  alt="Cathedral Façade Detail"
                  style={{ width: "80px", height: "70px", objectFit: "cover", borderRadius: "8px" }}
                />
                <div>
                  <h6 style={{ color: "var(--cathedral-navy)", fontSize: "0.95rem", marginBottom: "3px", fontWeight: 700 }}>
                    42-Meter Romanesque Towers
                  </h6>
                  <small style={{ color: "#6b7c91" }}>Twin bell towers visible across the historic old quarter of Madurai.</small>
                </div>
              </div>
            </div>
          </div>

          {/* Mass Timings Schedule Box */}
          <div className="col-lg-6">
            <div className="mass-schedule-box">
              <div className="mass-schedule-header">
                <i className="fas fa-clock"></i>
                <div>
                  <h3>Mass Timings & Devotions</h3>
                  <small style={{ color: "#748396" }}>Join our liturgical worship at St. Mary's Cathedral</small>
                </div>
              </div>

              <div className="d-flex flex-column gap-2">
                {scheduleItems.map((item, idx) => (
                  <div key={idx} className="mass-item">
                    <span className={`mass-day-badge ${item.isDevotion ? "devotion" : ""}`}>
                      {item.badge}
                    </span>
                    <div className="mass-details">
                      <strong>{item.title}</strong>
                      <span>{item.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 pt-3 border-top text-center" style={{ borderColor: "#eee6d8" }}>
                <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                  <i className="fas fa-info-circle text-secondary me-1"></i>
                  Confessions are heard before daily morning Masses and on Saturday evenings. Special festive schedules are announced during Advent, Lent, and the Parish Feast.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
